// import axios from "axios";
import React, { useEffect, useState, useRef, useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import Grid from "@mui/material/Grid";
// import "./index.css";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import { IoIosArrowDropleftCircle } from "react-icons/io";
import useIsMobile from "@/hooks/useIsMobile";
import { MasterConfigContext } from "@/context/MasterConfigContext";
// import { Typography } from "@mui/material";
// import RectangleIcon from '@mui/icons-material/Rectangle';

const partyColor = {
  NDA: "#F57E20",
  BJP: "#F57E20",
  "BJP+": "#F57E20",
  BSP: "#0001FF",
  SP: "#CF2323",
  "SP+": "#CF2323",
  CONG: "#4B91CF",
  INDIA: "#4B91CF",
  "CONG+": "#4B91CF",
  OTH: "#575757",
  AAP: "#074200",
  "SAD+": "#F4C300",
  "TMC+": "#004169",
  TMC: "#004169",
  "JD(S)": "#019e3a",
  TMP: "#0474cc",
  "LEFT+": "#dc1c2c",
  NPP: "#f0ac04",
  "NDPP+": "#f42428",
  NPF: "#b4bcec",
  JJP: "#FFF112",
  "JJP+": "#FFF112",
  INLD: "#005747",
  "INLD+": "#005747",
  MAHAYUTI: "#F57E20",
  "MAHAYUTI+": "#F57E20",
  MVA: "#0001FF",
  "MVA+": "#0001FF",
  JMM: "#004B1F",
  "JMM+": "#004B1F",
  INC: "#4B91CF",
  "INC+": "#4B91CF",
  SENA: "#CF2323",
  "SENA+": "#CF2323",
  NCP: "#4B91CF",
  "NCP+": "#4B91CF",
  VBA: "#b4bcec",
  "VBA+": "#b4bcec",
};

const partyLogo = {
  BJP: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/bjp.jpg",
  "BJP+":
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/bjp.jpg",
  BSP: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/bsp.jpg",
  SP: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/sp.jpg",
  "SP+":
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/sp.jpg",
  CONG: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/inc.jpg",
  "CONG+":
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/inc.jpg",
  OTH: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  AAP: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/aap.jpg",
  "SAD+": "#F4C300",
  "TMC+":
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/aitc.jpg",
  TMC: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/aitc.jpg",
  "JD(S)": "#019e3a",
  TMP: "#0474cc",
  "LEFT+": "#dc1c2c",
  NPP: "#f0ac04",
  "NDPP+": "#f42428",
  NPF: "#b4bcec",
  INDIA:
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/default-partylogo.jpg",
  NDA: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/bjp.jpg",
  JJP: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/jananayak_janata_party_logo.jpg",
  "JJP+":
    "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/jananayak_janata_party_logo.jpg",
  INLD: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/indian_national_lok_dal_icon.png",
  "INLD+":
    "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/indian_national_lok_dal_icon.png",
  MAHAYUTI:
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  "MAHAYUTI+":
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  MVA: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  "MVA+":
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  JMM: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/jharkhand_mukti_morcha_logo-1.png",
  "JMM+":
    "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/jharkhand_mukti_morcha_logo-1.png",
  INC: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/indian_national_congress_hand_logo-1.png",
  "INC+":
    "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/indian_national_congress_hand_logo-1.png",
  SENA: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  "SENA+":
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  NCP: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  "NCP+":
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  VBA: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  "VBA+":
    "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
};

const NameColors = [
  "#96288B",
  "#409031",
  "#00A5E3",
  "#BE1C2F",
  "#EB0304",
  "#004877",
  "#B42730",
  "#FFA07A",
  "#FFCC80",
  "#FFB6C1",
  "#00A5E3",
  "#BE1C2F",
  "#EB0304",
  "#004877",
  "#B42730",
  "#409031",
  "#00A5E3",
  "#BE1C2F",
  "#EB0304",
  "#004877",
  "#B42730",
];

function ExitPollRegionalComponentV2({
  exitPoll2019Data = [],
  exitPoll2024Data = [],
  masterKey = "",
}) {
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];
  const [stateData, setStateData] = useState(
    electionKeys?.exitDataYear == 2020 ? exitPoll2019Data : []
  );
  const [showExitPoll, setShowExitPoll] = useState(false);

  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollableWidth, setScrollableWidth] = useState(0);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const isMobile = useIsMobile();

  // Ref to the scrollable div
  const scrollableDivRef = useRef(null);
  const scrollableFixedRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  // Function to handle scrolling the div
  const scrollDiv = (amount) => {
    const newScrollPosition = scrollPosition + amount;

    setScrollPosition(newScrollPosition);

    scrollableDivRef.current.scrollTo({
      left: newScrollPosition,
      behavior: "smooth", // Optional: smooth scrolling effect
    });
  };
  useEffect(() => {
    // Calculate the width of the scrollable content once the component is mounted
    if (scrollableDivRef?.current?.scrollWidth) {
      const contentWidth = scrollableDivRef.current.scrollWidth;
      const limit =
        contentWidth > 500 ? contentWidth - 500 : contentWidth + 500;

      let temp = parseInt(scrollableDivRef.current.offsetWidth);
      setScrollableWidth(temp);
      setCanScrollRight(scrollPosition < limit);
      setCanScrollLeft(scrollPosition > 0);
    }
  }, [scrollableDivRef, scrollPosition, scrollableFixedRef]);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    // console.log('start' , touchStartX.current , 'end' , touchEndX.current , 'width' , scrollableWidth , 'scrollPosition' , scrollPosition)
    if (touchStartX.current - touchEndX.current > 50) {
      if (canScrollRight) {
        scrollDiv(scrollableWidth);
      }
    }

    if (touchStartX.current - touchEndX.current < -50) {
      if (canScrollLeft) {
        // console.log('scrollableWidth' , scrollableWidth)
        scrollDiv(-scrollableWidth);
      }
    }
  };

  useEffect(() => {
    if (showExitPoll) {
      const slides = scrollableDivRef.current;
      slides.addEventListener("touchstart", handleTouchStart);
      slides.addEventListener("touchmove", handleTouchMove);
      slides.addEventListener("touchend", handleTouchEnd);

      return () => {
        slides.removeEventListener("touchstart", handleTouchStart);
        slides.removeEventListener("touchmove", handleTouchMove);
        slides.removeEventListener("touchend", handleTouchEnd);
      };
    }
  }, [
    showExitPoll,
    scrollableWidth,
    scrollPosition,
    canScrollLeft,
    canScrollRight,
  ]);

  const fetchPartiesData = async () => {
    try {
      const exitPollAPI = `https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json`;

      const response = await fetch(exitPollAPI,{
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
      if (!response.ok) throw new Error("Failed to fetch exit poll data");

      const data = await response.json();
      const PollData = data?.find((item) => item?.agency === "AgencyDL");

      if (PollData) {
        // setExitPollData(PollData);
        setShowExitPoll(true);

        // Process the data after updating state
        let tempStateData = PollData;
        let resultAwaited = true;

        tempStateData?.pollData?.forEach((each) => {
          each?.partyData?.forEach((item) => {
            if (item.midRange || item.percentageValue) {
              resultAwaited = false;
            }
            item.percentage =
              item.percentageValue ||
              (item.midRange && tempStateData?.totalSeats
                ? parseInt((item.midRange * 100) / tempStateData.totalSeats)
                : 0);
          });

          each.resultAwaited = resultAwaited;
        });

        setStateData(tempStateData);
      } else {
        throw new Error("No data found for the specified agency");
      }
    } catch (e) {
      console.error("Error in fetching exit poll data:", e);
      setShowExitPoll(false);
    }
  };

  useEffect(() => {
    fetchPartiesData();

    if (electionKeys?.showExitPoll) {
      const interval = setInterval(fetchPartiesData, 10000);
      return () => clearInterval(interval); // Cleanup interval on unmount
    }
  }, []);

  return (
    <div className="MainContainer" ref={scrollableFixedRef}>
      <div className="LeftDiv">
        {stateData?.pollData && stateData?.pollData.length > 2 && (
          <IoIosArrowDropleftCircle
            // color="secondary"
            aria-label="add"
            disabled={!canScrollLeft}
            style={{
              height: "36px",
              width: "36px",
              color: canScrollLeft ? "#828282" : "#E2E2E2",
              cursor: "pointer",
            }}
            onClick={() => scrollDiv(-scrollableWidth)}
          />
        )}
      </div>
      <div ref={scrollableDivRef} className="CenterDiv">
        {stateData?.pollData?.map((item, index) => {
          return (
            <div
              className={
                stateData?.pollData?.length > 1 ? "AgencyDiv" : "AgencyDiv2"
              }
              key={index}
              style={{
                position: "relative",
                // display: "grid",
                // minWidth: "100%",
              }}
            >
              <div className="AgencyNameDiv">
                <div
                  style={{
                    padding: "6px",
                    backgroundColor: NameColors[index],
                    textAlign: "center",
                    borderRadius: "4px",
                    width: "95%",
                  }}
                >
                  <span
                    style={{
                      color: "#FFF",
                      fontSize: isMobile ? "1rem" : "1.25rem",
                      fontFamily: ["Rubik", "sans-serif"],
                    }}
                  >
                    {item?.agencyName}
                  </span>
                </div>
              </div>
              {item?.partyData.map((child, index) => {
                return (
                  <div key={index} style={{ display: "grid" }}>
                    <div className="PartyDataDiv">
                      <div className="PartyNameDiv">
                        <img
                          src={`${partyLogo[child.partyName]}`}
                          alt="party Symbol"
                          style={{ width: "38px", height: "40px" }}
                        ></img>
                        <span style={{ paddingLeft: "4px", fontWeight: "700" }}>
                          {child.partyName}
                        </span>
                      </div>
                      <div className="PartySeatDiv">
                        <span style={{ paddingLeft: "4px", fontWeight: "700" }}>
                          {child?.percentageValue
                            ? child.percentage + "%"
                            : child.seats}
                        </span>
                      </div>
                    </div>
                    <div className="SeatSlider">
                      <div
                        className="WinnigSeat"
                        style={{
                          backgroundColor: `${partyColor[child.partyName]}`,
                          borderRadius: "8px",
                          display: "flex",
                          width: `${child.percentage}%`,
                          height: "14px",
                          justifySelf: "center",
                        }}
                      ></div>
                    </div>
                  </div>
                );
              })}
              {item.resultAwaited && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                >
                  <img
                    src="https://akm-img-a-in.tosshub.com/sites/elections/static/images/exit-poll/india-loader.gif"
                    alt="result awaited"
                    style={{ width: "50%", height: "50%" }}
                  ></img>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="RightDiv">
        {stateData?.pollData && stateData?.pollData.length > 2 && (
          <IoIosArrowDroprightCircle
            style={{
              height: "36px",
              width: "36px",
              color: canScrollRight ? "#828282" : "#E2E2E2",
              cursor: "pointer",
            }}
            // color="secondary"
            aria-label="add"
            disabled={!canScrollRight}
            onClick={() => scrollDiv(scrollableWidth)}
          />
        )}
      </div>
    </div>
  );
}
export default ExitPollRegionalComponentV2;
